import axios from "axios";
//设置axios为form-data
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.transformRequest = [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
}]
axios.defaults.transformQuery = [function (data) {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret
}]
// 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
  
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// const dev = '/api/tuqiang-campus';
//  const dev = 'http://apitest.jimicloud.com';
const api = {
    // GET_CURRENT_USER:dev+'/getCurrentUser',//GET 获取用户信息
    // GET_Status:dev+'/getStatus',//GET 获取设备状态
    // POST_PLAYBACK_RECORD:dev+'/playbackRecord',//POST回放记录
    // POST_ALARMINFO:dev+'/alarmInfo/queryAlarmType',//post获取所有告警类型
    // POST_QUERYALARMINFO:dev+'/alarmInfo/queryAlarmInfo',//post获取告警列表
    // POST_INSTRUCTION:dev+'/instruction/queryInstructionType',//获取设备指令类型,
    // POST_queryInstructionByParam:dev+'/instruction/queryInstructionByParam',//获取设备指令详情
    // POST_geozone:dev+'/geozone/queryGeozoneInfo',//获取围栏列表
    // POST_setGeozoneAlarm:dev+'/geozone/setGeozoneAlarm',//设置围栏进出告警
    // POST_deleteGeozone:dev+'/geozone/deleteGeozone',//删除围栏
    // POST_addGeozone:dev+'/geozone/addGeozone',//添加围栏
    // POST_instruction:dev+'/instruction/sendInstruction',//发送设备指令
  /**
   * 统一get请求
   * @param {string} url请求路径 请求路径
   * @param {*} params 数据
   * @param {funciton} callback 成功回调
   */
  $get(url, callback, params) {
    
    let prevent = true;
    if (!prevent) {
      return;
    }
    prevent = false;
    axios
      .get(url, {
        params  
      })
      .then(res => {
        prevent = true;
        callback(res.data);
        
        return;
      })
      .catch(err => {
        prevent = true;
        // mui.toast(err);
        return;
      });
  },

  /**
   * 统一post请求
   * @param {string} url 请求路径
   * @param {*} data 数据
   * @param {funciton} callback 成功回调
   */
  $post(url, callback, data) {
    let prevent = true;
    if (!prevent) {
      return;
    }
    prevent = false;
    axios({
      method: "POST",
      url: url,
      data: data
    })
    .then(res => {
     if (res.data) {
       
      prevent = true;
      callback(res.data);
     }else{
     
     }
      
    })
    .catch(err => {
      prevent = true;
      // mui.toast(err);
      return;
    });
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/http/http.js